"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var RecursiveTemplate_1 = __importDefault(require("../RecursiveTemplate"));
/**
 * Wrapper component to make sure RecursiveTemplateSchema receives correct props
 * @param param0
 */
var InfopageTemplate = function (_a) {
    var orientation = _a.orientation, _b = _a.template, schema = _b.schema, components = _b.components, keys = _b.keys, infopageContent = _a.infopageContent, contentMetadata = _a.contentMetadata;
    var templateProps = {
        currentComponentSchema: schema.components,
        currentTemplate: components === null || components === void 0 ? void 0 : components[orientation],
        mediaKeys: keys,
        infopageContent: infopageContent,
        contentMetadata: contentMetadata
    };
    return react_1.default.createElement(RecursiveTemplate_1.default, __assign({}, templateProps));
};
exports.default = InfopageTemplate;
//# sourceMappingURL=InfopageTemplate.js.map